@if (useStandard) {
  <crm-standard-single-select
    [descriptorApiUrl]="descriptorUrl"
    [selectedValue]="selectedApprovalScheme"
    (selectedValueChange)="onSelected($any($event))"
    [class]="class"
    [styleClass]="styleClass"
    [showClear]="showClear"
    [disabled]="disabled"
    [isError]="isError"
    [appendTo]="appendTo"></crm-standard-single-select>
} @else {
  <crm-single-select
    [options]="approvalSchemas"
    [selectedItem]="selectedApprovalScheme"
    (selectedItemChange)="onSelected($event)"
    [showClear]="showClear"
    [styleClass]="styleClass"
    [class]="class"
    [appendTo]="appendTo"
    [disabled]="disabled"
    [isError]="isError"
    [loading]="loading"></crm-single-select>
}
